import React, { useState, useEffect } from 'react';
import { colors } from '../styles/colors';
import { fonts, fontWeights } from '../styles/fonts';
import { content } from '../constants/content';

function Investment() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleViewPitchDeck = () => {
    window.open('/FOI Emp Power Presentation v1.pdf', '_blank');
  };

  return (
    <section id="investment" style={isMobile ? styles.sectionMobile : styles.section}>
      <h2 style={isMobile ? styles.titleMobile : styles.title}>
        {content.investment.title}
      </h2>
      
      <p style={isMobile ? styles.subtitleMobile : styles.subtitle}>
        {content.investment.subtitle}
      </p>
      
      <button style={isMobile ? styles.buttonMobile : styles.button} onClick={handleViewPitchDeck}>
        {content.buttons.viewPitchDeck}
      </button>
    </section>
  );
}

const styles = {
  section: {
    padding: '100px 60px',
    backgroundColor: '#F8F9FA',
    textAlign: 'center',
  },
  sectionMobile: {
    padding: '60px 20px',
    backgroundColor: '#F8F9FA',
    textAlign: 'center',
  },
  title: {
    fontSize: '48px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '30px',
  },
  titleMobile: {
    fontSize: '32px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '20px',
    lineHeight: '1.2',
  },
  subtitle: {
    fontSize: '18px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    maxWidth: '950px',
    margin: '0 auto 50px auto',
    lineHeight: '1.6',
  },
  subtitleMobile: {
    fontSize: '16px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    maxWidth: '100%',
    margin: '0 auto 40px auto',
    lineHeight: '1.6',
    padding: '0 10px',
  },
  button: {
    padding: '16px 40px',
    backgroundColor: colors.primary,
    color: colors.white,
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: fontWeights.semibold,
    fontFamily: fonts.primary,
    cursor: 'pointer',
  },
  buttonMobile: {
    padding: '14px 32px',
    backgroundColor: colors.primary,
    color: colors.white,
    border: 'none',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: fontWeights.semibold,
    fontFamily: fonts.primary,
    cursor: 'pointer',
    width: '90%',
    maxWidth: '300px',
  },
};

export default Investment;